import React from 'react'

const alignClass = (align) =>
	align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left'

export const TableWrap = ({ children, className = '', minWidth = 'min-w-[720px]' }) => (
	<div
		className={`w-full overflow-x-auto rounded-2xl border border-slate-200 bg-white ${className}`}
	>
		<table className={`w-full ${minWidth} border-collapse text-sm`}>{children}</table>
	</div>
)

export const Th = ({ children, className = '', align = 'left' }) => (
	<th
		className={`sticky top-0 z-10 whitespace-nowrap border-b border-slate-200 bg-slate-50/95 px-3 py-3 ${alignClass(
			align,
		)} text-[11px] font-semibold uppercase tracking-wide text-slate-500 ${className}`}
	>
		{children}
	</th>
)

export const Td = ({ children, className = '' }) => (
	<td className={`border-b border-slate-100 px-3 py-3 align-middle ${className}`}>
		{children}
	</td>
)

export const EmptyRow = ({ colSpan, text = 'Maʼlumot topilmadi' }) => (
	<tr>
		<td colSpan={colSpan} className="px-3 py-14 text-center text-slate-400">
			{text}
		</td>
	</tr>
)
